import React from "react";

const CompanyCell = ({ row }) => {
  return <div>{row?.company?.companyName}</div>;
};

export default CompanyCell;
